import { useState, useEffect } from "react";
import PageLayout from "components/layout/PageLayout";
import { useTranslation } from "react-i18next";
import SettingsCard from "components/commons/SettingsCard";
import SuccessMessage from "components/commons/SuccessMessage";
import { useGetSafetySettingsQuery, useSetSafetySettingsMutation } from "./api/safetySettingsApiSlice";

export default function SafetySettings() {
    const [t] = useTranslation(["global", "safety"]);

    const [settings, setSettings] = useState();
    const [statusMessage, setStatusMessage] = useState("");

    const {
        data,
        isFetching,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch
    } = useGetSafetySettingsQuery();

    const [saveSettings, {
        isLoading: saveIsLoading,
        isSuccess: saveIsSuccess,
        isError: saveIsError,
        error: saveError,
        reset: resetSaveStatus
    }] = useSetSafetySettingsMutation();

    useEffect(() => {
        if (data && isSuccess) {
            setSettings(data);
        }
    }, [data, isSuccess]);

    const handleChange = (key, value) => {
        setSettings((prevSettings) => ({
            ...prevSettings,
            [key]: value,
        }));
        resetSaveStatus();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        saveSettings(settings);
    };

    const content = (
        <div>
            {isError ? (
                <p>{t("Failed to load settings.")} {error?.data?.message || error?.status}</p>
            ) : isSuccess && settings ? (
                <form onSubmit={handleSubmit}>
                    {saveIsSuccess && <SuccessMessage />}
                    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3 mb-4">
                        <div className="col">
                            <SettingsCard
                                label={t("safety:setting.pre_alarm.title")}
                                description={t("safety:setting.pre_alarm.desc")}
                                logo={<i className="fa-solid fa-stopwatch"></i>}
                                value={settings.countdown}
                                measureUnit={t("unit.seconds")}
                                onChange={(e) => handleChange("countdown", parseInt(e.target.value, 10))}
                                inputType="number"
                            />
                        </div>
                        <div className="col">
                            <SettingsCard
                                label={t("safety:setting.calmdown.title")}
                                description={t("safety:setting.calmdown.desc")}
                                logo={<i className="fa-solid fa-hand"></i>}
                                value={settings.calmdown}
                                measureUnit={t("unit.seconds")}
                                onChange={(e) => handleChange("calmdown", parseInt(e.target.value, 10))}
                                inputType="number"
                            />
                        </div>
                        <div className="col">
                            <SettingsCard
                                label={t("safety:setting.emergency_phone_number.title")}
                                description={t("safety:setting.emergency_phone_number.desc")}
                                logo={<i className="fa-solid fa-phone-volume"></i>}
                                value={settings.emergency_number}
                                onChange={(e) => handleChange("emergency_number", e.target.value)}
                                inputType="text"
                            />
                        </div>
                    </div>
                    <button type="submit" className="btn btn-primary"><i className="fa-solid fa-floppy-disk"></i> {t("action.save")}</button>


                </form>
            ) : <></>}
        </div>
    );

    return (
        <PageLayout
            pageTitle={t("Safety Settings")}
            bodyContent={content}
            onPageRefresh={refetch}
            isLoadingContent={saveIsLoading || isFetching}
            isLoadingPage={isLoading}
            isError={saveIsError || isError}
            errorMsg={saveError || error}
        />
    );
}
